import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginForm from '../components/LoginForm';

/**
 * Page for user login
 */
const LoginPage = () => {
  const { isAuthenticated, user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // If user is already authenticated, redirect appropriately
  useEffect(() => {
    if (!loading && (isAuthenticated || user)) {
      // Check if there's a return destination
      const returnTo = location.state?.returnTo;
      const returnState = location.state?.returnState;
      
      if (returnTo && returnState) {
        navigate(returnTo, { state: returnState });
      } else {
        navigate('/admin');
      }
    }
  }, [isAuthenticated, user, loading, navigate, location.state]);
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div 
        className="max-w-md w-full p-8 rounded-xl shadow-2xl"
        style={{ backgroundColor: 'rgba(20, 20, 20, 0.8)' }}
      >
        {/* Logo/branding area */}
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold bg-gradient-to-r from-white to-purple-400 text-transparent bg-clip-text">
            Join a Group Class
          </h1>
          {location.state?.returnTo && (
            <p className="text-purple-400 text-sm mt-2">
              Please log in to continue with your class registration.
            </p>
          )}
        </div>
        
        {/* Login form */}
        <LoginForm />
        
        {/* Back to classes link */}
        <div className="mt-6 text-center">
          <button 
            type="button" 
            onClick={() => navigate('/classes')}
            className="text-gray-400 hover:text-gray-300 text-sm focus:outline-none"
          >
            ← Back to class schedule
          </button>
        </div>
      </div>
      
      {/* Footer */}
      <p className="mt-8 text-sm text-gray-500">
        © {new Date().getFullYear()} Mandarin Tutor HK. All rights reserved.
      </p>
    </div>
  );
};

export default LoginPage;